// import apolloClient from './../apolloClient.js'

const state = {
  showModal: null,
  statisticParams: {
    dateFrom: '',
    dateTo: '',
    cityId: null,
    techcenterId: null,
    status: null,
    userId: null,
    mode: 'search'
  }
}

const mutations = {
  SET_DASHBOARD_SHOW_MODAL (state, value) {
    state.showModal = value
  },
  SET_DASHBOARD_STATISTIC_PARAMS (state, params) {
    state.statisticParams = params
  }
}

const actions = {
  dashboardShowModal: ({commit}, value) => {
    commit('SET_DASHBOARD_SHOW_MODAL', value)
  },
  dashboardSetStatisticParams: ({commit}, params) => {
    commit('SET_DASHBOARD_STATISTIC_PARAMS', params)
  }
// removeAvatar: ({commit}) => {
//   Vue.http.post(apiDomain + 'api/user/upload-avatar', {}, {headers: getHeader()}).then((response) => {
//     commit('SET_AVATAR', null)
//   })
//
// }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/dashboardStore.js